<template>
    <div>
        <div class="col-md-12 statbox mb-4">
            <div>
                <div class="box">
                    <span class="title widget-title" v-html="widget.attributes.title.attributeValue"></span>
                    <span class="chart-control">
                        <i class="fad fa-print fa-lg"></i>
                        <i class="fad fa-download fa-lg"></i>
                        <i class="fad fa-times fa-lg" @click="closeChart"></i>
                    </span>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <line-chart v-if="widget.type == '01' || widget.type == '02' || widget.type == '03' || widget.type == '06'" :settings="options" :values="data"></line-chart>
                        <bar-chart v-else-if="widget.type == '04'" :settings="options" :values="data"></bar-chart>
                    </div>
                    <div class="col-md-12 chart-info-panel">
                        <template v-if="widget.type != '03' && widget.type != '04' && widget.type != '06'">
                            <div class="col-md-6 offset-md-3 div-table-responsive">
                                <table class="table-responsive">
                                    <thead>
                                        <tr>
                                            <th>min</th>
                                            <th>avg</th>
                                            <th>max</th>
                                            <th>val. corrente</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="values">
                                            <td class="min">
                                                <template v-if="aggregation['MIN'] != undefined && aggregation['MIN'][0] != undefined && ready">
                                                    <span v-html="(aggregation['MIN'][0].stringValue != undefined ? aggregation['MIN'][0].stringValue: '') + ' ' + (aggregation['MIN'][0].stringUnit != undefined ? aggregation['MIN'][0].stringUnit: '')"></span>
                                                </template>
                                                <template v-else>
                                                    <span v-if="ready">{{ "notAvailable" | translate }}</span>
                                                    <span v-else></span>
                                                </template> 
                                            </td>
                                            <td class="avg">
                                                <template v-if="aggregation['AVG'] != undefined && aggregation['AVG'][0] != undefined && ready">
                                                    <span v-html="(aggregation['AVG'][0].stringValue != undefined ? aggregation['AVG'][0].stringValue: '') + ' ' + (aggregation['AVG'][0].stringUnit != undefined ? aggregation['AVG'][0].stringUnit: '')"></span>
                                                </template>
                                                <template v-else>
                                                    <span v-if="ready">{{ "notAvailable" | translate }}</span>
                                                    <span v-else></span>
                                                </template> 
                                            </td>
                                            <td class="max">
                                                <template v-if="aggregation['MAX'] != undefined && aggregation['MAX'][0] != undefined && ready">
                                                    <span v-html="(aggregation['MAX'][0].stringValue != undefined ? aggregation['MAX'][0].stringValue: '') + ' ' + (aggregation['MAX'][0].stringUnit != undefined ? aggregation['MAX'][0].stringUnit: '')"></span>
                                                </template>
                                                <template v-else>
                                                    <span v-if="ready">{{ "notAvailable" | translate }}</span>
                                                    <span v-else></span>
                                                </template>   
                                            </td>
                                            <td class="current">
                                                <template v-if="aggregation['LAST'] != undefined && aggregation['LAST'][0] != undefined && ready">
                                                    <span v-html="(aggregation['LAST'][0].stringValue != undefined ? aggregation['LAST'][0].stringValue: '') + ' ' + (aggregation['LAST'][0].stringUnit != undefined ? aggregation['LAST'][0].stringUnit: '')"></span>
                                                </template>
                                                <template v-else>
                                                    <span v-if="ready">{{ "notAvailable" | translate }}</span>
                                                    <span v-else></span>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                        <template v-if="widget.type == '03'">
                            <div class="col-md-8 offset-md-2">
                                <table>
                                    <thead>
                                        <tr>
                                            <template v-for="index in [0, 1, 2]">
                                                <th :key="'aggregation-title-current-' + index">
                                                    <span v-html="aggregation['LAST_' + index] != undefined && mapping[aggregation['LAST_' + index][0]['paramId']] != undefined ? mapping[aggregation['LAST_' + index][0]['paramId']]: ''"></span>
                                                </th>
                                                <th :key="'aggregation-title-fun-' + index">
                                                    <span v-html="aggregation['FUN_' + index] != undefined ? widget.attributes.functionDescription.attributeValue: ''"></span>
                                                </th>
                                            </template>                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="values">
                                            <template v-for="index in [0, 1, 2]">
                                                <td :key="'aggregation-value-last-' + index" class="value">
                                                    <template v-if="aggregation['LAST_' + index] != undefined && aggregation['LAST_' + index][0] != undefined && ready">
                                                        <span v-html="(aggregation['LAST_' + index][0].stringValue != undefined ? aggregation['LAST_' + index][0].stringValue: '') + ' ' + (aggregation['LAST_' + index][0].stringUnit != undefined ? aggregation['LAST_' + index][0].stringUnit: '')"></span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="ready">{{ "notAvailable" | translate }}</span>
                                                        <span v-else></span>
                                                    </template> 
                                                </td>
                                                <td :key="'aggregation-value-fun-' + index" class="fun">
                                                    <template v-if="aggregation['FUN_' + index] != undefined && aggregation['FUN_' + index][0] != undefined && ready">
                                                        <span v-html="(aggregation['FUN_' + index][0].stringValue != undefined ? aggregation['FUN_' + index][0].stringValue: '') + ' ' + (aggregation['FUN_' + index][0].stringUnit != undefined ? aggregation['FUN_' + index][0].stringUnit: '')"></span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="ready">{{ "notAvailable" | translate }}</span>
                                                        <span v-else></span>
                                                    </template> 
                                                </td>
                                            </template>                                            
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template> 
                    </div>
                </div>
            </div>
            <overlay :enabled="loading"></overlay>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import notificator from '@/mixins/notificator';

    import Overlay from '@/components/Overlay.vue';

    import LineChart from '@/components/Charts/Line.vue';
    import BarChart from '@/components/Charts/Bar.vue';

    const color = ['#0e5381', '#71ba51', '#008bcf', '#5C5C60'];

    export default {
        props: ['widget'],

        components: {Overlay, LineChart, BarChart},

        mixins: [notificator],

        data() {
            return {
                ready: false,
                loading: false,
                timer: null,
                data: {},
                aggregation: {},
                options: {},

                mapping: {} //Mappo i param ID con i nomi (per grafici con + linee)
            }
        },

        created() {   
            this.generateOptions();

            this.start();
        },

        computed: {
            ...mapGetters([
                'token',
                'clientId'             
            ])
        },

        methods: {
            generateOptions() {
                switch (this.widget.type) {
                    case '01': case '02': case '06':
                        //1 linea
                        this.$set(this, 'options', {
                            chart: {type: 'spline', zoomType: 'x'},
                            title: {text: null},
                            xAxis: {'type': 'datetime'},
                            yAxis: [
                                {
                                    labels: {style: {color: 'Highcharts.getOptions().colors[0]'}},
                                    title: {text: (this.widget.attributes.paramDescription.attributeValue + (this.widget.attributes.unit != undefined ? ' [' + this.widget.attributes.unit.attributeValue + ']' : '')), style: {color: 'Highcharts.getOptions().colors[0]'}},
                                }
                            ],
                            tooltip: {crosshairs: true, 'shared': true, pointFormat: '{series.name}: <b>{point.y:.1f}</b>'},
                            credits: {enabled: false},
                            plotOptions: {
                                spline: {
                                    marker: {
                                        radius: 2,
                                        lineColor: '#666666',
                                        lineWidth: 1
                                    }
                                },
                                style: {
                                    fontFamily: 'Rubik'
                                },
                                series: {
                                    events: {
                                        legendItemClick: 'disabled'
                                    },
                                }
                            },
                            series: []
                        });

                    break;
                    
                    case '03':
                        //3 linee
                        this.$set(this, 'options', {
                            chart: {type: 'spline', zoomType: 'x'},
                            title: {text: null},
                            xAxis: {'type': 'datetime'},
                            yAxis: [
                                {
                                    labels: {style: {color: 'Highcharts.getOptions().colors[0]'}},
                                    title: {text: (this.widget.attributes.title.attributeValue + (this.widget.attributes.unit != undefined ? ' [' + this.widget.attributes.unit.attributeValue + ']' : '')), style: {color: 'Highcharts.getOptions().colors[0]'}},
                                }
                            ],
                            tooltip: {crosshairs: true, 'shared': true, pointFormat: '{series.name}: <b>{point.y:.1f}</b>'},
                            credits: {enabled: false},
                            plotOptions: {
                                spline: {
                                    marker: {
                                        radius: 2,
                                        lineColor: '#666666',
                                        lineWidth: 1
                                    }
                                },
                                style: {
                                    fontFamily: 'Rubik'
                                },
                                series: {
                                    events: {
                                        // legendItemClick: 'disabled'
                                    },
                                }
                            },
                            series: []
                        });
                    break;
                    
                    case '04':
                        //Columns
                        this.$set(this, 'options', {
                            chart: {type: 'column'},
                            title: {text: null},
                            xAxis: {
                                type: "datetime",
                                labels: {
                                    format: "{value:%d}"
                                },
                                min:  moment().startOf('month').unix() * 1000,
                                max:  moment().endOf('month').unix() * 1000,
                                tickInterval: 24 * 3600 * 1000
                            },
                            yAxis: [
                                {
                                    labels: {style: {color: 'Highcharts.getOptions().colors[0]'}},
                                    title: {text: (this.widget.attributes.title.attributeValue + (this.widget.attributes.unit != undefined ? ' [' + this.widget.attributes.unit.attributeValue + ']' : '')), style: {color: 'Highcharts.getOptions().colors[0]'}},
                                }
                            ],
                            credits: {enabled: false},
                            plotOptions: {
                                column: {
                                    pointPadding: 0.2,
                                    borderWidth: 0
                                },
                                style: {
                                    fontFamily: 'Rubik'
                                },
                                series: {
                                    events: {
                                        legendItemClick: 'disabled'
                                    },
                                }
                            }
                        });
                    break;
                
                    default: break;
                }                
            },

            start() {
                this.getData()

                /*
                TODO RIABILITARE CON AGGIORNAMENTO PUNTI
                this.timer = setInterval(() => {
                    this.getData()
                }, 60000);
                */

                if(this.widget.type == '04' || this.widget.type == '06') {
                    this.timer = setInterval(() => {
                        this.getTSData();
                    }, 60000);           
                }
                
                /* CANCELLARE SOPRA */
            },

            getData() {
                this.getTSChartData();
                this.getTSData();
            },

            generateDevicesQueries() {
                var offset = new Date().getTimezoneOffset();
                
                var aqDatetimeLowerbound = moment().subtract(1, 'days').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                var aqDatetimeUpperbound = moment().add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                
                switch (this.widget.type) {
                    case '01': case '02':
                        return [{
                            'aggregation': {
                                'mode': 'LAST'
                            },
                            'aqDatetimeLowerbound': aqDatetimeLowerbound,
                            'aqDatetimeUpperbound': aqDatetimeUpperbound,
                            'deviceIds': [this.widget.deviceId], 
                            'paramIds': [parseInt(this.widget.attributes.paramId.attributeValue)],
                            'queryId': 'LAST',
                            'readingType': this.widget.attributes.readingType.attributeValue          
                        },
                        {
                            'aggregation': {
                                'mode': 'MAX'
                            },
                            'aqDatetimeLowerbound': aqDatetimeLowerbound,
                            'aqDatetimeUpperbound': aqDatetimeUpperbound,
                            'deviceIds': [this.widget.deviceId], 
                            'paramIds': [parseInt(this.widget.attributes.paramIdMax.attributeValue)],
                            'queryId': 'MAX',
                            'readingType': this.widget.attributes.readingType.attributeValue          
                        },
                        {
                            'aggregation': {
                                'mode': 'MIN'
                            },
                            'aqDatetimeLowerbound': aqDatetimeLowerbound,
                            'aqDatetimeUpperbound': aqDatetimeUpperbound,
                            'deviceIds': [this.widget.deviceId], 
                            'paramIds': [parseInt(this.widget.attributes.paramIdMin.attributeValue)],
                            'queryId': 'MIN',
                            'readingType': this.widget.attributes.readingType.attributeValue          
                        },
                        {
                            'aggregation': {
                                'mode': 'AVG'
                            },
                            'aqDatetimeLowerbound': aqDatetimeLowerbound,
                            'aqDatetimeUpperbound': aqDatetimeUpperbound,
                            'deviceIds': [this.widget.deviceId], 
                            'paramIds': [parseInt(this.widget.attributes.paramIdAvg.attributeValue)],
                            'queryId': 'AVG',
                            'readingType': this.widget.attributes.readingType.attributeValue          
                        }];
                    
                    // break;
                    
                    case '03':
                        var devicesQueries = [];

                        for (let index = 0; index <= 2; index++) {
                            devicesQueries.push({
                                'aggregation': {
                                    'mode': 'LAST'
                                },
                                'aqDatetimeLowerbound': aqDatetimeLowerbound,
                                'aqDatetimeUpperbound': aqDatetimeUpperbound,
                                'deviceIds': [this.widget.deviceId], 
                                'paramIds': [parseInt(this.widget.attributes['paramId' + (index + 1)].attributeValue)],
                                'queryId': 'LAST_' + index,
                                'readingType': this.widget.attributes.readingType.attributeValue
                            },
                            {
                                'aggregation': {
                                    'mode': this.widget.attributes['functionAggregationMode'].attributeValue
                                },
                                'aqDatetimeLowerbound': aqDatetimeLowerbound,
                                'aqDatetimeUpperbound': aqDatetimeUpperbound,
                                'deviceIds': [this.widget.deviceId], 
                                'paramIds': [parseInt(this.widget.attributes['functionParamId' + (index + 1)].attributeValue)],
                                'queryId': 'FUN_' + index,
                                'readingType': this.widget.attributes.readingType.attributeValue
                            });
                        }

                        return devicesQueries;                        
                    // break;
                
                    default: break;
                }
            },

            getTSData() {
                if(this.widget.type == '04' || this.widget.type == '06')
                    return;
                
                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getTSData', {devicesQueries: this.generateDevicesQueries()})
                .catch(error => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: error}));            

                    this.data = {};

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: 200}));

                    if(data.deviceQueriesResponse != undefined) {
                        this.aggregation = data.deviceQueriesResponse;
                    } else {
                        this.aggregation = {};
                    }

                    if(!this.ready)
                        this.ready = true;
                });          
            },
            
            generateTSChartDataRequest() {
                var offset = new Date().getTimezoneOffset();

                var paramIds = [];
                
                if(this.widget.attributes.paramId != undefined) {
                    paramIds = [parseInt(this.widget.attributes.paramId.attributeValue)];
                    this.mapping[this.widget.attributes.paramId.attributeValue] = this.widget.attributes.paramDescription.attributeValue;
                } else if(this.widget.attributes.paramId1 != undefined && this.widget.attributes.paramId2 != undefined && this.widget.attributes.paramId3 != undefined) {
                    paramIds = [parseInt(this.widget.attributes.paramId1.attributeValue), parseInt(this.widget.attributes.paramId2.attributeValue), parseInt(this.widget.attributes.paramId3.attributeValue)];
                    
                    this.mapping[this.widget.attributes.paramId1.attributeValue] = this.widget.attributes.paramDescription1.attributeValue;
                    this.mapping[this.widget.attributes.paramId2.attributeValue] = this.widget.attributes.paramDescription2.attributeValue;
                    this.mapping[this.widget.attributes.paramId3.attributeValue] = this.widget.attributes.paramDescription3.attributeValue;
                }

                var request = {
                    clientId: this.clientId,
                    sessionToken: this.token,
                    deviceIds: [this.widget.deviceId],
                    paramIds: paramIds,
                    aqDatetimeLowerbound: this.widget.type != '04' ? 
                        moment().subtract(1, 'days').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z':
                        moment().startOf('month').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
                    aqDatetimeUpperbound: moment().add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
                    fillGap: true,
                }          

                if(this.widget.type == '04') {
                    request['aggregation'] = {
                        frequency: 'DAILY',
                        mode: 'CONS'
                    }
                }

                return request;
            },

            getTSChartData() {

                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getTSChartData', {request: this.generateTSChartDataRequest()})
                .catch(error => {
                    if(!this.ready)
                    this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSChartData', code: error}));            

                    this.data = {};

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSChartData', code: 200}));

                    if(data != undefined && data.paramList != undefined) {
                        //TODO AGGIUNGERE AGGIORNAMENTO PUNTI

                        var tmp = {};
                        var colorIndex = 0;

                        for (let key in data.paramList) {
                            let lineColor = color[colorIndex];
                            tmp[key] = {
                                name: this.mapping[key] != undefined ? this.mapping[key]: '',
                                type: this.widget.type != '04' ? 'areaspline': 'column',
                                marker: {symbol: 'circle', enabled: true, radius: 2},
                                data: data.paramList[key],
                                color: lineColor,
                                fillOpacity: 0.1,
                                lineWidth: 0.8,
                                showInLegend: this.widget.type == '01' || this.widget.type == '04' ? false: true
                            };
            
                            colorIndex++;
                        }

                        this.$set(this, 'data', tmp);
                    } else
                        this.data = {};
                    
                    if(!this.ready)
                        this.ready = true;
                });          
            },

            closeChart() {
                this.$emit('close-chart');
            },

            overlay(action) {
                this.loading = action;
            }
        },

        beforeDestroy: function(){
            clearInterval(this.timer);
        }
    }
</script>

<style>
.div-table-responsive {
    overflow-x: visible;
}
.table-responsive {
    width: 100%;
    border-top:.2em solid #2185D0;
}
</style>